const STORAGE_KEY = 'nord.browserClientIdentity.v1';

export function generateBrowserUuid(
  cryptoProvider: Crypto | undefined = (globalThis as { crypto?: Crypto }).crypto,
): string {
  if (typeof cryptoProvider?.randomUUID === 'function') {
    try {
      return cryptoProvider.randomUUID();
    } catch {
      // Some older/insecure browser contexts expose the method but reject calls to it.
    }
  }
  if (typeof cryptoProvider?.getRandomValues !== 'function') {
    throw new Error('Browser cryptography is unavailable.');
  }
  const bytes = cryptoProvider.getRandomValues(new Uint8Array(16));
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hexadecimal = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return [
    hexadecimal.slice(0, 8),
    hexadecimal.slice(8, 12),
    hexadecimal.slice(12, 16),
    hexadecimal.slice(16, 20),
    hexadecimal.slice(20),
  ].join('-');
}

export function browserClientIdentity(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null && stored.length > 0 && stored.length <= 128) {
      return stored;
    }
    const created = generateBrowserUuid();
    localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    // Sandboxed/private contexts may reject storage; the session still gets a random identity.
    return generateBrowserUuid();
  }
}
